export const ru = {
  'hx': {
    'all': 'Все',
    'atol': {
      'taxationType': {
        'esn': 'единый сельскохозяйственный налог',
        'osn': 'общая',
        'patent': 'патентная система налогообложения',
        'usnIncome': 'упрощенная доход',
        'usnIncomeOutcome': 'упрощенная доход минус расход'
      }
    },
    'bank-account-select': {
      'placeholder': {
        'selectBank': 'Выберите счет банка'
      }
    },
    'bank-select': {
      'selectBank': 'Выберите банк'
    },
    'brand-select': {
      'selectBrand': 'Выберите бренд'
    },
    'btn': {
      'apply': 'Применить',
      'back': 'Назад',
      'cancel': 'Отмена',
      'close': 'Закрыть',
      'save': 'Сохранить'
    },
    'call-audio': {
      'play': 'Воспроизвести'
    },
    'city-select': {
      'selectCity': 'Выберите город'
    },
    'client-checker': {
      'bonus': 'Бонусы',
      'mobileNum': 'Только мобильные номера',
      'ng': {
        'clear': 'Очистить'
      },
      'placeholder': {
        'num': 'Новый'
      },
      'addBirthDateNote': 'Добавление даты рождения'
    },
    'client-edit-modal': {
      'changeProfile': 'Изменить профиль клиента',
      'profile': 'Новый профиль клиента'
    },
    'client-edit': {
      'activeCoins': 'Бонусы',
      'btn': {
        'addMail': 'Добавить e-mail',
        'addNote': 'Добавить заметку',
        'addPhone': 'Добавить телефон'
      },
      'client': 'Данные клиента',
      'coin': {
        'th': {
          'activationDate': 'Активна с',
          'amount': 'Кол-во',
          'expireDate': 'Активна до',
          'operation': 'Операция'
        }
      },
      'coins': 'Бонусы',
      'comment': {
        'title': 'Комментарии',
        'date': 'Дата',
        'actor': 'Автор'
      },
      'happyDay': 'День рождения',
      'info': 'Дополнительная информация',
      'mobileNum': 'Только мобильные номера',
      'mobileNumber': 'Мобильный номер',
      'name': 'ФИО',
      'ng': {
        'change': 'Изменить',
        'delete': 'Удалить',
        'deleteContact': 'Удалить контакт'
      },
      'num': 'Номер телефона',
      'table': {
        'body': {
          'blacklist': 'в черном списке'
        },
        'head': {
          'blacklist': 'Черный список',
          'brand': 'Бренд',
          'note': 'Заметка'
        }
      },
      'ts': {
        'clientExists': 'Клиент с таким номером существует',
        'commentEmpty': 'Комментарии не заполнены',
        'dataUpdated': 'Данные обновлены',
        'error': 'Произошла ошибка',
        'mail': 'Электронная почта',
        'phone': 'Телефон',
        'textNum': 'Введите мобильный номер телефона'
      }
    },
    'client-indicator': {
      'nb': {
        'blacklist': 'черный список: {{ blackListInfo }}',
        'note': 'заметки: {{client}}'
      }
    },
    'client-list': {
      'title': 'Клиенты',
      'subtitle': 'Профили, контакты и дни рождения в одном месте',
      'total': 'Всего клиентов',
      'scope': 'в доступных магазинах',
      'scopeBrandCountry': 'Клиенты выбранного бренда и страны',
      'results': 'Список клиентов',
      'filtered': 'Показаны клиенты по выбранным условиям',
      'unfiltered': 'Все клиенты, доступные вам',
      'pageSize': 'Строк на странице',
      'clear': 'Сбросить фильтры',
      'loading': 'Загружаем клиентов…',
      'emptyTitle': 'Клиенты не найдены',
      'emptyFiltered': 'Попробуйте изменить запрос или дату рождения.',
      'emptyUnfiltered': 'В доступных магазинах пока нет клиентов.',
      'emptyBrandCountry': 'Для выбранных бренда и страны клиентов пока нет.',
      'noName': 'Без имени',
      'noPhone': 'Без телефона',
      'open': 'Открыть клиента',
      'months': {'1': 'Январь', '2': 'Февраль', '3': 'Март', '4': 'Апрель', '5': 'Май', '6': 'Июнь', '7': 'Июль', '8': 'Август', '9': 'Сентябрь', '10': 'Октябрь', '11': 'Ноябрь', '12': 'Декабрь'},
      'loadError': 'Не удалось загрузить клиентов. Попробуйте ещё раз.',
      'errorId': 'Код ошибки: {{id}}',
      'retry': 'Повторить загрузку',
      'btn': {
        'search': 'поиск'
      },
      'ng': {
        'change': 'Изменить',
        'time': 'Время сохранения: {{ date }} - по времени Астаны'
      },
      'placeholder': {
        'name': 'ФИО или номер телефона'
      },
      'table': {
        'head': {
          'happyDay': 'День рождения',
          'name': 'ФИО',
          'num': 'Номер'
        }
      },
      'filter': {
        'birthDate': 'День рождения',
        'day': 'День',
        'month': 'Месяц',
        'brand': 'Бренд',
        'country': 'Страна',
        'anyDay': 'Любой день',
        'anyMonth': 'Любой месяц',
        'query': 'Поиск'
      }
    },
    'client-profile': {
      'saveError': 'Не удалось сохранить клиента. Проверьте номер телефона и попробуйте ещё раз.',
      'contacts': 'Дополнительные контакты',
      'noContacts': 'Дополнительных контактов нет',
      'noProperties': 'Для клиента ещё нет заметок по брендам',
      'noCoins': 'Бонусных операций пока нет',
      'noComments': 'Комментариев пока нет',
      'phonePlaceholder': 'Номер телефона',
      'invalidContact': 'Проверьте дополнительный телефон или email.',
      'invalidEmail': 'Введите корректный email',
      'invalidPhone': 'Введите полный номер телефона',
      'chooseDate': 'Выберите дату',
      'clearDate': 'Очистить дату',
      'previousMonth': 'Предыдущий месяц',
      'nextMonth': 'Следующий месяц',
      'year': 'Год рождения',
      'page': 'Страница {{page}}',
      'previousPage': 'Предыдущая страница',
      'nextPage': 'Следующая страница'
    },
    'client-property-edit-modal': {
      'blacklisted': 'В черном списке',
      'brand': 'Бренд',
      'no': 'Нет',
      'note': 'Заметка',
      'title': 'Заметка по клиенту',
      'ts': {
        'save': 'Данные сохранены'
      },
      'yes': 'Да'
    },
    'client-search': {
      'placeholder': {
        'loading': 'Идет поиск...',
        'nameClient': 'Введите имя или телефон клиента',
        'noFind': 'Не найдено',
        'startSearch': 'Для поиска начните печатать'
      }
    },
    'closed': 'Закрыто',
    'cmp': {
      'gis-address': {
        'hasNoDelivery': 'Не доставляем'
      }
    },
    'comment-add': {
      'mention': 'Выбрав метку будет отправлено дополнительное уведомление'
    },
    'comment-list': {
      'actor': 'Автор',
      'addComment': 'Добавить комментарий',
      'comment': 'Комментарий',
      'date': 'Дата',
      'previous': 'предыдущий'
    },
    'company': {
      'address': 'Адрес',
      'contract': 'Основание',
      'letterOfAuthorityDate': 'Дата',
      'letterOfAuthorityFile': {
        'uploaded': 'Доверенность загружена!',
        'uploadRequired': 'Необходимо загрузить доверенность!'
      },
      'letterOfAuthorityFileId': 'Доверенность',
      'letterOfAuthorityFileLink': {
        'tooltip': 'Просмотреть загруженную доверенность'
      },
      'letterOfAuthorityNumber': 'Номер',
      'representativeFullname': 'ФИО',
      'saveForAuthorityForm': 'Сохраните данные о компании',
      'title': 'Наименование',
      'uin': 'БИН'
    },
    'confirm': {
      'cancel': 'Отменить',
      'ok': 'ОК',
      'title': 'Подтверждение действия'
    },
    'country-select': {
      'placeholder': {
        'chooseCountry': 'Выберите страну'
      }
    },
    'data-select': {
      'btn': {
        'close': 'Закрыть',
        'today': 'Сегодня'
      }
    },
    'date-range-select': {
      'lastMonth': 'Прошлый месяц',
      'lastQuarter': 'Прошлый квартал',
      'lastWeek': 'Прошлая неделя',
      'month': 'Месяц',
      'quarter': 'Квартал',
      'week': 'Неделя'
    },
    'daterangepicker': {
      'lastMonth': 'Прошлый месяц',
      'lastQuarter': 'Прошлый квартал',
      'lastWeek': 'Прошлая неделя',
      'month': 'Месяц',
      'quarter': 'Квартал',
      'week': 'Неделя'
    },
    'dictionary-select': {
      'placeholder': {
        'selectExpense': 'Выберите тип расхода'
      }
    },
    'diff': {
      'deliveryType': {
        'DELIVERY': 'Доставка курьером',
        'PICKUP': 'Самовывоз'
      },
      'is': {
        'false': 'убрали',
        'happy': {
          'apps': {
            'vanilla': {
              'event': {
                'dto': {
                  'OrderDiffDto': {
                    'action': 'Действие',
                    'address': 'Адрес',
                    'bookedClient': 'Забронировавший клиент',
                    'cartExpireDate': 'Время корзины',
                    'cartRangeId': 'Время доставки (корзина)',
                    'cashless': 'Безнал',
                    'cityId': 'Город',
                    'clientCash': 'Наличка',
                    'clientId': 'Клиент',
                    'currency': 'Валюта',
                    'date': 'Дата',
                    'decor': 'Оформление',
                    'decored': 'Оформлен',
                    'decorText': 'Оформление',
                    'deliveryLatitude': 'Широта',
                    'deliveryLongitude': 'Долгота',
                    'deliveryRangeId': 'Время доставки',
                    'deliveryTimeRange': 'Уточнить время для курьера',
                    'deliveryType': 'Тип доставки',
                    'deliveryUserId': 'Курьер',
                    'employeeId': 'Скидка на сотрудника',
                    'enabled': 'Активен',
                    'entrance': 'Подъезд',
                    'fiscalDate': 'Дата фиск.',
                    'flat': 'Квартира',
                    'floor': 'Этаж',
                    'important': 'Избранное',
                    'inscription': 'Надпись',
                    'invoice': 'Счёт-фактуру',
                    'locked': 'Заблокирован',
                    'modifyDate': 'Дата изменения',
                    'modifyUserId': 'Изменил',
                    'note': 'Примечание',
                    'number': 'Номер',
                    'operationType': 'Тип операции',
                    'organizationTitle': 'Наименование орг.',
                    'organizationUin': 'ИИН/БИН орг.',
                    'paid': 'Статус оплаты',
                    'paidActor': 'Принял оплату',
                    'parentOrderId': 'Основной заказ',
                    'payment': 'Платеж',
                    'paymentDate': 'Дата оплаты',
                    'paymentUserFullname': 'Принял оплату',
                    'paymentUserId': 'Принял оплату (id)',
                    'phone': 'Телефон',
                    'rahmet': 'Рахмет',
                    'removed': 'Удален',
                    'revoked': 'Возвращен',
                    'seen': 'Просмотрен',
                    'seenUserIds': 'Кем просмотрен',
                    'senim': 'SENIM',
                    'sourceFrom': 'Источник заказа',
                    'status': 'Статус',
                    'storeId': 'Магазин',
                    'storePaymentType': 'Тип оплаты',
                    'subTotal': 'Всего',
                    'taxNumber': 'Номер налога',
                    'taxSeries': 'Налоговый режим',
                    'taxSum': 'Сумма налога',
                    'total': 'Итого',
                    'underSalary': 'Статус под зп',
                    'uniqueNumber': 'Уникальный номер',
                    'wkCashboxFactoryNumber': 'ЗНМ',
                    'wkCashboxRegistrationNumber': 'РНМ',
                    'wkCashboxTaxNumber': 'Фискальный номер',
                    'wkFiscalNumber': 'ФП'
                  }
                }
              }
            }
          },
          'dao': {
            'hc': {
              'dto': {
                'payment': {
                  'PaymentInfoDto': {
                    'payment/cash': 'Наличные',
                    'payment/checkingAccount': 'Платежное поручение',
                    'payment/dept': 'Долг',
                    'payment/forte': 'FortePay',
                    'payment/halyk': 'HalykPay',
                    'payment/kaspi': 'kaspi.kz',
                    'payment/pos': 'POS',
                    'payment/rahmet': 'Рахмет',
                    'payment/senim': 'Senim'
                  }
                }
              }
            }
          }
        },
        'paid': {
          'false': 'не оплачен',
          'true': 'оплачен'
        },
        'true': 'добавили'
      },
      'kind': {
        'A': 'добавил(а) в список',
        'D': 'удалил(а)',
        'E': 'изменил(а)',
        'N': 'добавил(а)'
      },
      'path': {
        'address': 'Адрес',
        'callId': 'Запись звонка',
        'cash': 'Наличка',
        'cashless': 'Безнал',
        'checkingAccountFileId': 'Платёжное поручение',
        'city': 'Город',
        'clientCash': 'Наличка',
        'clientId': 'Клиент',
        'clientType': 'Тип клиента',
        'courier': 'Курьер',
        'date': 'Дата',
        'decorText': 'Оформление',
        'deliveryLatitude': 'Широта',
        'deliveryLongitude': 'Долгота',
        'deliveryTimeRange': 'Уточнить время для курьера',
        'deliveryType': 'Тип доставки',
        'discounts': 'Скидки',
        'employeeId': 'Скидка на сотрудника',
        'entrance': 'Подъезд',
        'files': 'Файлы',
        'flat': 'Квартира',
        'floor': 'Этаж',
        'from': 'Источник заказа',
        'important': 'Избранное',
        'invoice': 'Счёт-фактуру',
        'note': 'Примечание',
        'paid': 'Статус оплаты',
        'paymentType': 'Тип оплаты',
        'phone': 'Телефон',
        'products': 'Продукты',
        'rahmet': 'Рахмет',
        'reason': 'Причина',
        'senim': 'SENIM',
        'store': 'Магазин',
        'subTotal': 'Всего',
        'total': 'Итого',
        'underSalary': 'Статус под зп'
      }
    },
    'enum-select': {
      'placeholder': {
        'choose': 'Выберите'
      }
    },
    'enum': {
      'AccountType': {
        'BANK_ACCOUNT': 'Безналичные',
        'CASH': 'Наличные'
      },
      'AccrualType': {
        'DAILY': 'ежедневно',
        'HOURLY': 'часовая',
        'MONTHLY': 'помесячно'
      },
      'CoinOperation': {
        'CANCELLED': 'Отменены',
        'EARNED': 'Заработаны',
        'SPENT': 'Потрачены'
      },
      'ComponentType': {
        'cb': 'Касса',
        'cc': 'Call-center',
        'cf': 'Кондитерская',
        'delivery': 'Курьер',
        'kiosk': 'Киоск',
        'manager': 'Менеджер',
        'profile': 'Профиль'
      },
      'Currency': {
        'AZN': 'manat',
        'EUR': 'euro',
        'KGS': 'сом',
        'KZT': 'теңге',
        'RUB': 'рубль',
        'USD': 'dollar',
        'UZS': 'so\'m'
      },
      'EmployeeType': {
        'EMPLOYEE': 'постоянный договор',
        'TEMP': 'временный договор'
      },
      'Gender': {
        'FEMALE': 'Ж',
        'MALE': 'М'
      },
      'InvoiceStatus': {
        'ACCEPTED': 'принят',
        'CANCELLED': 'отменён',
        'DISCARDED': 'списан',
        'INVENTORY': 'инвентаризация',
        'NEW': 'создан',
        'REJECTED': 'отклонён',
        'RESTORATION': 'реставрация',
        'SENT': 'отправлен',
        'SHIPMENT': 'на доставке'
      },
      'MaritalStatus': {
        'DIVORCED': 'разведена/разведён',
        'MARRIED': 'замужем/женат',
        'SINGLE': 'не замужем/не женат',
        'WIDOWED': 'вдова/вдовец'
      },
      'OperationType': {
        'ADJUSTMENT': 'Корректировка',
        'COLLECTION': 'Инкассация',
        'PURCHASE': 'Закуп',
        'WITHDRAWAL': 'Снятие'
      },
      'PaymentType': {
        'CASH': 'Наличка',
        'CHECKING_ACCOUNT': 'Платежное поручение',
        'COIN': 'Бонусы',
        'DEBT': 'Долг',
        'FORTE': 'Forte',
        'HALYK': 'Halyk',
        'KASPI': 'kaspi',
        'KASPI_POS': 'kaspi POS',
        'PAYBOX': 'Paybox',
        'POS': 'POS',
        'RAHMET': 'Рахмет',
        'SENIM': 'SENIM',
        'UZ_PAYBOX': 'Paybox VM'
      },
      'ProductStatus': {
        'CANCELLED': 'отменён',
        'CART': 'корзина',
        'CART_CANCELLED': 'отменён',
        'DISCARDED': 'списан',
        'PAID_CANCELLED': 'отменён',
        'RECEIVED': 'доставлен',
        'REFUNDED': 'возврат',
        'REGISTER': 'регистрация',
        'RESERVED': 'создан',
        'TRANSFER': 'отправлен'
      },
      'SourceSystem': {
        'CALLCENTER': 'Call-center',
        'CASHBOX': 'Касса',
        'CONFECTIONARY': 'Кондитерская',
        'INSTAGRAM': 'Instagram',
        'KIOSK': 'Киоск',
        'MANAGER': 'Менеджер',
        'ONLINE': 'Сайт',
        'ONLINE_APP': 'Приложение',
        'TELEGRAM': 'Telegram бот',
        'WEBKASSA': 'webkassa',
        'WHATSAPP': 'Whatsapp'
      },
      'StorageInvoiceStatus': {
        'ACCEPTED': 'принят',
        'CANCELLED': 'отменён',
        'NEW': 'создан',
        'REJECTED': 'отклонён',
        'SENT': 'отправлен'
      },
      'TimeInterval': {
        'day': 'Дата',
        'month': 'Месяц',
        'week': 'Неделя',
        'year': 'Год'
      },
      'TimesheetType': {
        'ABSENCE': 'Прогул',
        'ATTENDANCE': 'Явка',
        'HOLIDAY': 'Праздник',
        'SICK': 'Больничный',
        'VACATION': 'Отпуск'
      }
    },
    'error-handler': {
      'balance': 'В {{msg}} пополните баланс следующими продуктами: {{product}}',
      'limit': 'Превышен лимит по продуктам: {{product}}'
    },
    'event-diff': {
      'changeData': 'Дата изменения',
      'changeOrder': 'Заказ изменил(а)',
      'noChange': 'Нет изменений',
      'table': {
        'body': {
          'num': 'шт'
        },
        'head': {
          'after': 'Стало',
          'before': 'Было'
        }
      },
      'title': 'История изменений заказа',
      'ts': {
        'discount': 'скидка: {{pi}}'
      }
    },
    'event': {
      'COIN_EARNED': 'бонус начислен',
      'COMPANY_INFO_SAVED': 'данные о юр лице',
      'FISCALIZATION_REFUND': 'чек(возврат)',
      'FISCALIZATION_SELL': 'чек',
      'none': 'не определён',
      'ORDER_ARCHIVED': 'архивирован',
      'ORDER_CANCELLED': 'отменён',
      'ORDER_COMPLETED': 'завершён',
      'ORDER_CREATED': 'создан',
      'ORDER_CURBSIDE_PICKUP': 'вынос к обочине',
      'ORDER_CURBSIDE_PICKUP_SEEN': 'вынос к обочине [касса]',
      'ORDER_DECORED': 'оформлен',
      'ORDER_INITED': 'регистрация',
      'ORDER_MODIFIED': 'изменён',
      'ORDER_MODIFYING': 'начал изменение',
      'ORDER_PACKED': 'упакован',
      'ORDER_PAID': 'оплачен',
      'ORDER_RECEIVED': 'доставлен',
      'ORDER_REFUNDED': 'возврат',
      'ORDER_RETURNED': 'освободил',
      'ORDER_SHIPPED': 'на доставке',
      'ORDER_TAKEN': 'принял',
      'ORDER_TRANSFERRED': 'перенесен',
      'ORDER_UNARCHIVED': 'разархивирован',
      'PAY_INVOICE_SENT': 'счет на оплату',
      'PAYMENT_INVOICE_GENERATED': 'счет на оплату',
      'PAYMENT_STARTED': 'начал оплату',
      'PRODUCT_INVOICE_GENERATED': 'накладная на отпуск запасов на сторону',
      'PRODUCT_REFUNDED': 'возврат част.',
      'PUSH_NOTIFICATION_CREATED': 'уведомление(push)',
      'SERVICE_INVOICE_GENERATED': 'акт выполненных работ (оказанных услуг)',
      'SMS_NOTIFICATION_CREATED': 'смс создано',
      'SMS_NOTIFICATION_SENT': 'смс отправлено',
      'ORAL_ORDER_SELL': 'Отправлена покупка в Oral Gateway',
      'ORAL_ORDER_REFUND': 'Отправлен возврат в Oral Gateway',
      'WHATSAPP_NOTIFICATION_CREATED': 'whatsapp сообщение создано'
    },
    'faq-list': {
      'answer': 'Ответ',
      'answerHelpful': 'считают ответ полезным',
      'isAnswerHelpfulForYou': 'Для Вас ответ оказался полезным',
      'no': 'Нет',
      'search': 'Поиск',
      'title': 'FAQ',
      'yes': 'Да'
    },
    'feedback': {
      'confirmRemove': 'Вы действительно хотите удалить отзыв?'
    },
    'file-list': {
      'ng': {
        'delete': 'Удалить файл',
        'file': 'Временный файл',
        'success': '{{ file }} (загружен {{ date }} по времени Астаны)'
      }
    },
    'file-upload': {
      'mb': 'МБ',
      'size': 'Максимальный размер'
    },
    'form': {
      'fillRequiredFields': 'Укажите обязательные поля'
    },
    'gis-address': {
      'address': 'Укажите адрес',
      'btn': {
        'address': 'Указать набранный адрес',
        'refusal': 'Отказ'
      },
      'delivery-zone': 'Зона доставки',
      'flat': 'кв',
      'floor': 'эт',
      'noDelivery': 'Не доставляем',
      'noFind': 'Адрес не найден',
      'p': 'п',
      'search': 'Поиск...',
      'shop': 'Магазин',
      'showMap': 'Показать карту',
      'startText': 'Начните печатать',
      'text': 'не доставляет по адресу'
    },
    'hx-loader': {
      'noData': 'Нет данных'
    },
    'invoice-select': {
      'from': 'от',
      'placeholder': {
        'chooseInvoice': 'Выберите накладную'
      }
    },
    'lang': {
      'en': 'Английский',
      'kk': 'Казахский',
      'ru': 'Русский',
      'us': 'Английский'
    },
    'loading': {
      'create': {
        'finished': 'Завершаем создание заказа',
        'order': 'Создаём заказ'
      },
      'order': {
        'send': 'Отправляем заказ'
      },
      'save': 'Сохранение данных...'
    },
    'manual-address': {
      'address': 'Адрес доставки',
      'flat': 'кв',
      'floor': 'эт',
      'p': 'п'
    },
    'modal-user': {
      'birthDate': 'Дата рождения',
      'client': 'Клиент',
      'mobile': 'Мобильный телефон',
      'user': 'Пользователь'
    },
    'no': 'Нет',
    'nt': {
      'saved': 'Данные сохранены'
    },
    'operationDayClosed': 'Операционный день закрыт',
    'order-event-list': {
      'ts': {
        'noFindList': 'Не найден заказ отмены, обратитесь в тех поддержку',
        'orderCancel': 'Не найден заказ отмены, проверьте оплачен ли заказ'
      }
    },
    'order-receipt': {
      'ofd': 'ОФД',
      'checkSite': 'для проверки чека зайдите на сайт',
      'address': 'Адрес доставки',
      'cancellation': 'Причина отмены',
      'cashier': 'Кассир',
      'check': 'Чек',
      'checkHidden': 'Чек напечатан',
      'client': 'Клиент',
      'footer': '© Happy Tech App',
      'ng': {
        'courier': 'Курьер'
      },
      'noCheck': 'БЕЗ ЧЕКА',
      'note': 'Примечание',
      'paid': 'Спасибо за покупку!',
      'paidMethod': 'Способ оплаты',
      'printCheck': 'Печатать чек',
      'printedCheck': 'Чек напечатан',
      'return': 'возврат',
      'series': 'НДС Серия',
      'table': {
        'body': {
          'discount': 'Скидки',
          'text': 'в т.ч. НДС: 12%',
          'total': 'Всего',
          'totalAll': 'ИТОГО'
        },
        'head': {
          'name': 'Наименование',
          'num': 'Кол-во',
          'sum': 'Сумма',
          'weight': 'Вес'
        }
      },
      'text-1': 'ЗН ККТ',
      'text-10': 'НДС Серия',
      'text-11': 'СНО',
      'text-2': 'РН ККТ',
      'text-3': 'ФН',
      'text-4': 'ФД',
      'text-5': 'ФП',
      'text-6': 'Чек',
      'text-7': 'Дата',
      'text-8': 'Смена',
      'text-9': 'Сайт ФНС',
      'thanks': 'Спасибо за покупку!',
      'timeDelivery': 'Время доставки',
      'timePickup': 'Время самовывоза',
      'user': 'Получатель',
      'vat-amount': 'Сумма НДС 5%'
    },
    'order-refunded-list': {
      'from': 'от',
      'table': {
        'body': {
          'allTotal': 'Итого',
          'discount': 'Скидки',
          'total': 'Всего'
        },
        'head': {
          'name': 'Наименование',
          'num': 'Количество',
          'price': 'Цена',
          'sum': 'Сумма',
          'weight': 'Вес'
        }
      }
    },
    'paidOrderChangeForbidden': 'Нельзя изменять цену в оплаченном заказе',
    'pickups': {
      'notfound': 'Время самовывозов не найдено'
    },
    'product-info-select': {
      'placeholder': {
        'loading': 'Идет поиск...',
        'name': 'Введите наименование',
        'noFind': 'Не найдено',
        'search': 'Для поиска начните печатать'
      }
    },
    'product-list': {
      'alert': 'Оформление отключено на выбранную дату',
      'autoDeliveryInfo': 'Доставка добавляется при указании адреса',
      'btn': {
        'divide': 'Разделить',
        'refusal': 'Отказ'
      },
      'decorationDisabled': 'Оформление отключено на выбранную дату',
      'hiddenCategories': 'Скрытые категории',
      'hideCategory': 'Скрыть категорию',
      'notAbleToReserve': '{{title.ru}} - минимальное кол-во дней для приема заказа: {{minOrderDay}}, продажа после {{receiveAfterTime}}',
      'notAbleToReserveUntil': '{{title.ru}} - минимальное кол-во дней для приема заказа: {{minOrderDay}}, прием до {{untilOrderTime}}, продажа после {{receiveAfterTime}}',
      'productListEmpty': 'Список тортов пуст',
      'productNotForSale': 'Продукт не продаётся',
      'receiveAfterTime': '{{title.ru}} поступит в продажу после {{receiveAfterTime}}',
      'reserveNoFreeProduct': 'Бронирование невозможно. Нет свободных продуктов',
      'showCategory': 'Показать категорию',
      'ts': {
        'noChoose': 'Не выбраны категория и/или дата'
      }
    },
    'receipt': {
      'fiscalCheck': 'Фискальный чек',
      'fiscalization': 'Фискализация',
      'offlineMode': 'Чек сформирован в автономном режиме',
      'wkCashboxFactoryNumber': 'ЗНМ',
      'wkCashboxIdentificationNumber': 'ИНК ОФД',
      'wkCashboxRegistrationNumber': 'РНМ',
      'wkFiscalDate': 'Дата',
      'wkFiscalNumber': 'ФП'
    },
    'rejection-list': {
      'address': 'Адрес',
      'btn': {
        'search': 'поиск'
      },
      'city': 'Город',
      'data': 'Дата',
      'delivery': 'Доставка',
      'failures': 'Отказы',
      'pickup': 'Самовывоз',
      'placeholder': {
        'chooseCity': 'Выбрать город',
        'name': 'ФИО или номер телефона'
      },
      'products': 'Продукты',
      'promo': 'Промо',
      'registration': 'Оформление',
      'searchAddress': 'Поиск по адресу',
      'shop': 'Магазин',
      'table': {
        'head': {
          'absent': 'отсутствует',
          'address': 'Адреса',
          'city': 'Город',
          'client': 'Клиент',
          'data': 'Дата',
          'delivery': 'Доставка',
          'note': 'Примечание',
          'order': 'ID заказа',
          'pickup': 'Самовывоз',
          'products': 'Продукты',
          'promo': 'Промо',
          'registration': 'Оформление',
          'shop': 'Магазин',
          'timeCreate': 'Время создания'
        }
      }
    },
    'select': {
      'category': 'Выберите категорию'
    },
    'sms-info-modal': {
      'send': 'Отправлено провайдеру',
      'sendClient': 'Отправлено клиенту',
      'title': 'Информация о смс'
    },
    'sms': {
      'status': {
        'ACCEPTED': 'сообщение находится в принятом состоянии, т.е. прочитано вручную от имени абонента клиентской службой',
        'DELETED': 'сообщение было удалено',
        'DELIVERED': 'доставлено',
        'EXPIRED': 'истек период жизни СМС',
        'FAILED': 'внутренняя ошибка СМСЦ',
        'INVALID': 'внутренняя ошибка СМСЦ',
        'NEW': 'создано',
        'REJECTED': 'сообщение отклонили, происходит когда оператор отказывается его передавать',
        'SENT': 'отправлено',
        'UNDELIVERED': 'не доставлено, причина в коде'
      }
    },
    'store-search': {
      'placeholder': {
        'loader': 'Идет поиск...',
        'nameSearch': 'Введите наименование магазина',
        'noFind': 'Не найдено',
        'startSearch': 'Для поиска начните печатать'
      }
    },
    'store-select': {
      'placeholder': {
        'chooseShop': 'Выберите магазин'
      }
    },
    'user-search': {
      'placeholder': {
        'loader': 'Идет поиск...',
        'name': 'Введите имя или телефон пользователя',
        'noFind': 'Не найдено',
        'search': 'Для поиска начните печатать'
      }
    },
    'user-select': {
      'placeholder': {
        'loader': 'Идет поиск...',
        'name': 'Введите имя или телефон пользователя',
        'noFind': 'Не найдено',
        'search': 'Для поиска начните печатать'
      }
    },
    'yes': 'Да'
  }
};
